module.exports = __webpack_public_path__ + "static/img/news-20221025.f8a60d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20221025.png
// module id = zQeT
// module chunks = 0